import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On route change, if the URL has a hash (e.g. /#mental-health), scroll the
 * element with that id into view. Without this, clicking a hash link from a
 * different route just navigates - it doesn't trigger the browser's native
 * hash-scroll because React Router intercepts the navigation.
 *
 * Renders nothing.
 */
export default function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = hash.replace(/^#/, "");
    if (!id) return;

    // Defer to the next tick so target sections are mounted (especially
    // when the route just changed).
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 60);
    return () => clearTimeout(t);
  }, [pathname, hash]);

  return null;
}
